/**
 * 数科-臻有钱-提现申请成功页-弹窗 - 通过广告投放系统接入 https://fat-admaster.hellobike.cn/#/ssp/operation-mng
 * 广告位信息
 * 名称:数科-臻有钱-提现申请成功页-弹窗
 * uuid:e6af18f4335541cf93d1125aaa015e09
 */
import { Vue, Component } from 'vue-property-decorator';
import AdvCommonContainer from '../adv-common-container';

 @Component
export default class AdvApplySuccessPopup extends Vue {
  private render() {
    return (
         <AdvCommonContainer
           advMasterId="e6af18f4335541cf93d1125aaa015e09"
         />
    );
  }
}
